/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountType {
    PERSONAL = 'Personal',
    BUSINESS = 'Business'
}